export const PORTRAIT_URL = "/api/images/b36c8ca3-4e34-4803-9240-8e911104a0f3/file";
export const LOGO_URL = "/themaya-logo.png";

export const scrollToSection = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};
